/**
 * Sage Vendor to Conductor Vendor – Manual Run handler.
 * POSTs { sflId, tenantId } only. Backend lists Sage vendors via core/query
 * (Limit optional — blank = all), gets each by key, POSTs to Conductor.
 */

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}synctrack/sage/vendor-to-conductor-vendor`;

export const handleSageVendorToConductorVendorFlow = async (syncFlow) => {
  const token = localStorage.getItem('token');
  const tenantId = localStorage.getItem('tenantId');
  const sflId = syncFlow.instanceId || syncFlow.sfiId;

  if (!sflId) {
    throw new Error('Flow instance ID (sflId) is missing');
  }
  if (!tenantId) {
    throw new Error('tenantId is missing. Ensure you are logged in.');
  }

  const body = {
    sflId,
    tenantId: Number(tenantId),
  };

  const response = await fetch(API_BASE, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || `API error: ${response.status}`);
  }

  if (data.success === false) {
    throw new Error(data.message || 'Sage Vendor to Conductor Vendor run failed');
  }

  return data;
};
